class SessionHelper {
    setToken(token) {
        localStorage.setItem("token", token)
    }
    getToken() {
        return localStorage.getItem("token")
    }
    setUserDetails(UserDetails) {
        localStorage.setItem("userDetails", JSON.stringify(UserDetails))
    }
    getUserDetails() {
        return JSON.parse(localStorage.getItem("userDetails"))
    }
    setEmail(Email) {
        localStorage.setItem("email", Email)
    }
    getEmail() {
        return localStorage.getItem("email")
    }
    setOTP(OTP) {
        localStorage.setItem("OTP", OTP)
    }
    getOTP() {
        return localStorage.getItem("OTP")
    }
    // The email and OTP above exist only to carry state across the three
    // password-recovery screens. Clear them as soon as the reset succeeds, so a
    // spent OTP is not left behind in the browser storage of a counter PC that
    // several people use.
    clearRecovery() {
        localStorage.removeItem("email")
        localStorage.removeItem("OTP")
    }
    removeSessions = () => {
        // IndexedDB first, and awaited only as far as fire-and-forget allows.
        //
        // This used to be localStorage.clear() alone, which does not touch
        // IndexedDB at all — so a half-finished order written by the draft
        // autosave outlived the session that created it. On a counter PC shared
        // by a whole shift that meant one salesperson's order sitting on the
        // machine after they had gone home. It could not be restored into
        // someone else's screen, because draft keys are scoped per shop and
        // user (T-020), but leaving it there is still wrong.
        //
        // Imported lazily so that SessionHelper — which the axios client and
        // half the app depend on — does not pull localforage and the whole
        // draft module into every bundle that touches a token.
        import('../../drafts/draftStore')
            .then(({ clearAllDrafts }) => clearAllDrafts())
            .catch(() => {
                // Logging out must succeed even if the draft store cannot be
                // reached. Leaving the browser on a signed-in screen because
                // IndexedDB misbehaved would be the worse failure.
            })
            .finally(() => {
                localStorage.clear();
                window.location.href = "/login"
            })
    }
}
export const { setEmail, getEmail, setOTP, getOTP, clearRecovery, setToken, getToken, setUserDetails, getUserDetails, removeSessions } = new SessionHelper();